<template>
       
    <div class="container">
        <div class="py-3 text-center">            
            <h2>Resumen de Compra</h2>  
            <hr>          
        </div>

        <div class="row">
            <div class="col-md-4 order-md-2 mb-4">
            <h4 class="d-flex justify-content-between align-items-center mb-3">
                <span class="text-muted">Tu Carrito</span>
                <span class="badge badge-secondary badge-pill">1</span>
            </h4>
            <ul class="list-group mb-3">
                <li class="list-group-item d-flex justify-content-between lh-condensed">
                <div>
                    <h6 class="my-0">Nombre del Producto</h6>
                    <small class="text-muted">{{ planURL.nombre }}</small>
                </div>
                <span class="text-muted">$ {{ formatNumber(parseInt(planURL.valor)) }} {{ planURL.moneda }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                        <h6 class="my-0">Impuesto IVA (19%)</h6>
                    </div>
                    <span class="text-muted">Incluído</span>
                </li>                             
                <li class="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                        <h6 class="my-0">Costo Transacción</h6>
                    </div>
                    <span class="text-muted">$5.000 COP</span>
                </li>  
                <li class="list-group-item d-flex justify-content-between">
                <span>Total (COP)</span>
                <strong>$ {{ formatNumber(( parseInt(planURL.valor) + parseInt(5000) )) }} {{ planURL.moneda }}</strong>
                </li>
            </ul>            
            </div>
            <div class="col-md-8 order-md-1">
                <h4 class="mb-3">Métodos de Pago</h4>
                <b>Selecciona un método de pago para ir a pagar</b>
                <br><br>
                <div class="row">
                    <div class="col-md-12">  
                        <div class="row">                   
                            <div class="col-md-6">
                                <form v-if="paymentData" :action="paymentUrl" method="GET">
                                    <input type="hidden" name="public-key" :value="paymentData.publicKey" />
                                    <input type="hidden" name="currency" :value="paymentData.currency" />
                                    <input type="hidden" name="amount-in-cents" :value="paymentData.amountInCents" />
                                    <input type="hidden" name="reference" :value="paymentData.reference" />
                                    <input type="hidden" name="signature:integrity" :value="paymentData.signature" />
                                    <input type="hidden" name="redirect-url" value="https://admin.generaideasia.com/resultado-transaccion" />
                                    <button type="submit" class="btn btn-success" style="background-color: white; border: 1px solid #001995;">
                                        <img src="/images/logowompi.png" width="100%" height="auto">
                                    </button>
                                </form>
                                <b style="font-size: 10px; text-align: center;">Paga con Tarjetas nacionales e internacionales de las siguientes franquicias: Visa, Mastercard y American Express</b>
                            </div>   
                            <!-- <div class="col-md-6" style="background-color: white; border: 1px solid #001995;">
                                <img src="/images/paypal.png" width="100%" height="auto" style="padding: 25px;">
                            </div> -->
                        </div>   
                    </div>                               
                </div>
            </div>
        </div>
       
    </div>       
  
</template>
<script>

import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'

export default {
    name: 'dashboard',
    data: () => ({        
        paymentData: null,
        paymentUrl: "https://checkout.wompi.co/p/",
        planURL: [] 
    }),
    created() {
        this.getPlanURL();
    },
    mounted() {
        this.getPaymentData()
    },
    methods: {
        async getPaymentData() {
            return this.axios.get(configApi+'payment/wompi/get-data/'+this.$route.params.plan, {headers})
            .then(response => {
                this.paymentData = response.data;
            })
            .catch(error => {
                console.error('Error al obtener datos:', error);
            });
        },
        async getPlanURL() {
            return this.axios.get(configApi+'payment/buscar_plan/'+this.$route.params.plan, {headers})
            .then(response => {
                this.planURL = response.data.data[0];
            })
            .catch(error => {
                console.error('Error al obtener datos:', error);
            });
        },
        navegacion(menu, id_usuplataforma) {
            this.$router.push('/'+menu)
            localStorage.setItem('id_usuario_plataforma', id_usuplataforma)
        },
        formatNumber(number) {
            return number.toLocaleString('es-ES'); // Formato para separar por miles
        }
    }
}
</script>